
import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useLocation } from "react-router-dom"
import styled from "styled-components"
import Btn from "../../shared/button/Btn"
import { showModal } from "../../../features/modal/modalSlice"
import { useScrollLock } from "../../../hooks/useScrollLock"
import PageTopTitle from "../../shared/PageTopTitle"
import SmallSpinner from "../../shared/spinners/SmallSpinner"
import { handleActiveSelect } from "../../../features/layout/layoutSlice"
import InputText from "../../shared/input/new/InputText"
import {updateLoadPublishingType} from "../../../features/updateLoad/updateLoadSlice"
import getGivenDatePlusHours from "../../../helper/date/getGivenDatePlusHours"
import getCurrentDatePlusHours from "../../../helper/date/getCurrentDatePlusHours"
const Container = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 26;

    .modal{
        width: 800px;
        height: auto;
        display: flex;
        flex-direction: column;
        align-items: center;
        background-color: ${({theme}) => theme.mainBgColor};
        border-radius: 20px;

        .content{
            margin: 30px 0;
            padding: 20px;
            display: flex;
            flex-direction: column;
            align-items: center;
            background-color: ${({theme}) => theme.mainBgColor};
            border-radius: 20px;

            .p-grp{
                display: flex;
                flex-direction: column;
                align-items: center;
                gap: 15px;
                
                p{
                    font-size: var(--font-size-sm);
                    font-weight: var(--font-weight-md);
                    color: ${({theme}) => theme.mainTextColor};
                    text-align: center;
                    line-height: 1.5;
                }

            }

            
            .input-container{
                margin: 30px;
            }

        }

        .err-text{
                color: var(--color-main);
                font-size: var(--font-size-sm);
                font-weight: var(--font-weight-lg);
                text-align: center;
                line-height: 1.5;
                margin-bottom: 15px;
            }

        .button-grp{

            display: flex;
            align-items: center;
            gap: 20px;
            margin-bottom: 30px;
        }
    }
`

const PublishingType2Modal = () => {

    const location = useLocation()
    const dispatch = useDispatch()

    const {modalLocation } = useSelector(state => state.modal)
    const {loadItemData} = useSelector(state => state.loadList)
    const {isLoadingUpdateLoadPublishingType} = useSelector(state => state.updateLoad)

    const { lockScroll, unlockScroll } = useScrollLock();

    const [number, setNumber] = useState("")
    const [isErr, setIsErr] = useState(false)
    const [isSubmitted, setIsSubmitted] = useState(false)

    //! bu modal açıldığnda ekran ı lock lamak için
    useEffect(() => {
        lockScroll()

        return () => {
            unlockScroll()
        }
    }, [lockScroll, unlockScroll])

    //! bu başka bir sayfaya geçildiğinde modal ı kapatmak için
    useEffect(() => {
        if (location.pathname !== modalLocation) {
            dispatch(showModal(null))
        }
    }, [dispatch, location.pathname, modalLocation])

    const handleChange = (e) => {
        const text = e.target.value;
        // Sadece rakamları içeren bir regular expression kullanarak kontrol ediyoruz
        
        const onlyNumbers = /^[0-9.,;]*$|^$/;
        if (onlyNumbers.test(text) && text < 24){
            setNumber( text ? parseInt(text) : "");
        }
    }

    useEffect(() => {
        if(isSubmitted && number === ""){
            setIsErr(true)
        }
        else{
            setIsErr(false)
        }
    },[isSubmitted, number])

    const handleSubmit = () => {

        setIsSubmitted(true)

        if(!isErr && number > 0){
            dispatch(updateLoadPublishingType({
                
                waitingLoadId: loadItemData.id,
                publishingTypeId: 2,
                scheduledPublishTimeHours: number,
            }))
        }
    }

    

  return (
    <Container>
    <div className="modal" onClick={(e) => {e.stopPropagation(); dispatch(handleActiveSelect(null))}}>
        <div className="content">
            {
                //! bu eğer mevcutta yayınlama seçeneği 2 değil ise
                loadItemData.publishingTypeId !== 2 &&
                <div className="p-grp">
                    <p>Yükünüz önce yük arayan araçlarınıza sonra herkese yayınlanacak, kaç saat sonra herkese yayınlanacağını belirtin.</p>
                </div>
            }

            {
                //! bu eğer mevcutta yayınlama seçeneği 2 ise
                loadItemData.publishingTypeId === 2 &&
                <div className="p-grp">
                    <p>Yükünüz {getGivenDatePlusHours(3, loadItemData.scheduledPublishTime.slice(0, -1)).formattedDate} {getGivenDatePlusHours(3, loadItemData.scheduledPublishTime.slice(0, -1)).formattedTime} tarihinde herkese yayınlanacak, değişiklik yapmak istiyorsanız kaç saat sonra yayınlanacağını belirtin.</p>
                </div>
            }

            <div className="input-container">
                <InputText data={number} setData={handleChange} inputWidth={"100px"} labelText=""/>
            </div>

            {
                (loadItemData.publishingTypeId !== 2 && number > 0) &&
                <div className="p-grp">
                    <p>Yükünüz {getCurrentDatePlusHours(number).formattedDate} {getCurrentDatePlusHours(number).formattedTime} tarihinde herkese yayınlanacak, kaydetmek istiyor musunuz?</p>
                </div>
            }

            {
                (loadItemData.publishingTypeId === 2 && number > 0) &&
                <div className="p-grp">
                    <p>Yükünüz {getCurrentDatePlusHours(number).formattedDate} {getCurrentDatePlusHours(number).formattedTime} tarihinde herkese yayınlanacak, kaydetmek istiyor musunuz?</p>
                </div>
            }
        </div>


        {
            isErr &&
            <div className="p-grp">
                <p className="err-text">Lütfen en düşük 1 olmak üzere bir saat değeri girin.</p>
            </div>
        }

        <div className='button-grp'>
            <Btn color={"#fff"} bgColor={"#E85446"} borderColor="transparent" width="220px" radius={"10px"} handleClick={handleSubmit}>{isLoadingUpdateLoadPublishingType ? <SmallSpinner size={"20px"} color={"#fff"} bgColor={"#E85446"} /> : "Kaydet"}</Btn>
            <Btn color={"#E85446"} bgColor={"#fff"} borderColor="#E85446" width="220px" radius={"10px"} handleClick={()=> dispatch(showModal(null))}>Geri Dön</Btn>
        </div>
    </div>
    </Container>
  ) 
}

export default PublishingType2Modal